import { combineReducers } from 'redux';
import Example from '../reducers/example.reducer';

export default combineReducers({
    Example: Example
});